import React from 'react';

import {Link} from 'react-router';

import {getTeamSignoffsURL} from 'app/urls';
import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import type {
  DocTaskReportItemType,
  ReportResultSerializedType,
} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<DocTaskReportItemType>;
  timestampLabel?: string;
  memberLabel?: string;
}

export function RenderTeamSignoffTotals({
  result,
  timestampLabel,
  memberLabel,
}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{memberLabel ?? gt('Team')}</FixableHeader>
          <FixableHeader>{timestampLabel ?? gt('Timestamp')}</FixableHeader>
          <FixableHeader>{gt('Content Type')}</FixableHeader>
          <FixableHeader textAlign="right">{gt('Unsigned')}</FixableHeader>
          <FixableHeader textAlign="right">{gt('Signed')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <div className="d-flex align-items-center">
                <Link to={getTeamSignoffsURL(r['team_id'])}>
                  <i className="fa fa-users mr-1" /> {r['team']}
                </Link>
              </div>
            </td>
            <td>
              <DateText>{r['timestamp']}</DateText>
            </td>
            <td>{printContentType(r['content_type'])}</td>
            <td className="text-right">{r['unsigned_count']}</td>
            <td className="text-right">{r['signed_count']}</td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
